import glamorous from 'glamorous';

const Text = glamorous('p')(({ theme }) => ({
    color: theme.colorGrey,
    marginBottom: theme.space_md,
}));

export default Text;
